const X = ({
  width = 21,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.58153 2.5L8.85547 10.7735L2.54199 17.5H3.96302L9.49058 11.6107L13.9565 17.5H18.792L12.1649 8.76125L18.0415 2.5H16.6205L11.5301 7.92376L7.41699 2.5H2.58153ZM4.67121 3.53247H6.8926L16.702 16.4678H14.4807L4.67121 3.53247Z"
        fill="#010101"
      />
    </svg>
  );
};

export default X;
